import { Component } from '@angular/core';

@Component({
  selector: 'app-chevron-right-icon',
  standalone: true,
  templateUrl: './chevron-right-icon.component.html',
})
export class ChevronRightIconComponent {}
